import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


// attributes:
// icon (my custom attr) used as icon in the sidenav. value is material icon name
const routes = [{
    path: '/',
    name: 'Home',
    component: require('./components/content/Home.vue').default,
    icon: 'home',
    inmenu: true
  },

  {
    path: '/ueber-uns',
    name: 'Über uns',
    component: require('./components/content/Home.vue').default,
    icon: 'face',
    inmenu: true
  },
  {
    path: '/teams',
    name: 'Teams',
    component: require('./components/content/Home.vue').default,
    icon: 'group',
    inmenu: true
  },
  {
    path: '/kontakt',
    name: 'Kontakt',
    component: require('./components/content/Home.vue').default,
    icon: 'contact_mail',
    inmenu: true
  },
  {
    path: '*',
    name: 'Error',
    component: require('./components/partials/Error.vue').default,
    inmenu: false
  },

];


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
